
import { Card, CardContent } from "@/components/ui/card";

interface TranscriptDisplayProps {
  transcript: string;
}

const TranscriptDisplay = ({ transcript }: TranscriptDisplayProps) => {
  return (
    <Card>
      <CardContent className="p-6">
        <h3 className="text-lg font-semibold mb-4">Transcript</h3>
        <div className="bg-gray-50 dark:bg-gray-800 p-4 rounded-md min-h-[200px] max-h-[400px] overflow-y-auto">
          <p className="text-gray-700 dark:text-gray-300 whitespace-pre-wrap">{transcript}</p>
        </div>
        <div className="mt-4 text-sm text-gray-500">
          <p>This transcript was generated using OpenAI Whisper Large v3</p>
        </div>
      </CardContent>
    </Card>
  );
};

export default TranscriptDisplay;
